import { Link } from 'react-router-dom';

export default function LegalFooter() {
  return (
    <footer className="legal-footer">
      <div className="legal-footer-inner">
        <span>&copy; {new Date().getFullYear()} Affordable Telecom LLC &middot; New York, NY</span>
        <span className="legal-footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:hello@affordable-telecom.com">Contact</a>
        </span>
      </div>
    </footer>
  );
}
